import type { ValidationReportItem } from '@/domains/report/api/types';

export type ValueDisplay =
  | { kind: 'missing'; value: string; hasDetail: false }
  | { kind: 'single'; value: string; hasDetail: boolean }
  | { kind: 'sum'; value: string; hasDetail: true }
  | { kind: 'count'; value: string; hasDetail: true };

const dutchNumberFormat = new Intl.NumberFormat('nl-NL');

function parseDutchNumber(input: string | null): number | null {
  if (input === null) return null;
  const match = input.match(/-?\d{1,3}(?:\.\d{3})*(?:,\d+)?|-?\d+(?:,\d+)?/);
  if (!match) return null;
  const normalized = match[0].replace(/\./g, '').replace(',', '.');
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

export function computeValueDisplay(item: ValidationReportItem): ValueDisplay {
  const answers = item.answers;

  if (answers.length === 0) {
    return { kind: 'missing', value: 'Niet aanwezig', hasDetail: false };
  }

  if (answers.length === 1) {
    const only = answers[0]!;
    const hasEvidence = only.evidence.length > 0;
    return {
      kind: 'single',
      value: only.value ?? 'Niet aanwezig',
      hasDetail: hasEvidence,
    };
  }

  const parsed = answers.map((a) => parseDutchNumber(a.value));
  const allNumeric = parsed.every((n) => n !== null);

  if (allNumeric) {
    const sum = parsed.reduce<number>((acc, n) => acc + (n ?? 0), 0);
    return { kind: 'sum', value: dutchNumberFormat.format(sum), hasDetail: true };
  }

  return { kind: 'count', value: `${answers.length} antwoorden`, hasDetail: true };
}
